import { useEffect } from "react";

export default function CodeProtection() {
  useEffect(() => {
    // 1. Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // 2. Disable keyboard shortcuts (view source, dev tools, save page)
    const handleKeyDown = (e) => {
      // Ctrl+U (view source)
      if (e.ctrlKey && e.key === "u") { e.preventDefault(); return false; }
      // Ctrl+Shift+I (dev tools)
      if (e.ctrlKey && e.shiftKey && e.key === "I") { e.preventDefault(); return false; }
      // Ctrl+Shift+J (console)
      if (e.ctrlKey && e.shiftKey && e.key === "J") { e.preventDefault(); return false; }
      // Ctrl+Shift+C (inspect element)
      if (e.ctrlKey && e.shiftKey && e.key === "C") { e.preventDefault(); return false; }
      // F12 (dev tools)
      if (e.key === "F12") { e.preventDefault(); return false; }
      // Ctrl+S (save page)
      if (e.ctrlKey && e.key === "s") { e.preventDefault(); return false; }
      // Ctrl+P (print — allow but could be restricted)
    };

    // 3. Disable text selection on body (but allow on inputs)
    const handleSelectStart = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA" || e.target.isContentEditable) {
        return true;
      }
      e.preventDefault();
      return false;
    };

    // 4. Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // 5. Disable copy (except in inputs)
    const handleCopy = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return true;
      e.preventDefault();
      return false;
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("selectstart", handleSelectStart);
    document.addEventListener("dragstart", handleDragStart);
    document.addEventListener("copy", handleCopy);

    // 6. Add CSS to disable selection visually
    const style = document.createElement("style");
    style.textContent = `
      body { -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; }
      input, textarea, [contenteditable="true"] { -webkit-user-select: text; -moz-user-select: text; -ms-user-select: text; user-select: text; }
    `;
    document.head.appendChild(style);

    // 7. Console warning
    console.log(
      "%c STOP! %c This website and its source code are protected by copyright. Unauthorized copying, reproduction, or reverse engineering is strictly prohibited. %c Karine Lauzon RN Clinics",
      "background: #c9a86c; color: #fff; font-size: 20px; font-weight: bold; padding: 4px 8px;",
      "background: #1a1510; color: #c9a86c; font-size: 13px; padding: 4px 8px;",
      "background: #c9a86c; color: #fff; font-size: 11px; padding: 4px 8px;"
    );

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("selectstart", handleSelectStart);
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("copy", handleCopy);
      if (style.parentNode) style.parentNode.removeChild(style);
    };
  }, []);

  return null;
}
